import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35eddc30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image" }
const _hoisted_2 = { class: "portrait" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = {
  key: 0,
  class: "role"
}

import { computed } from "vue";
import { kebabCase, deburr } from "lodash";

interface Props {
  /** member name */
  name: string;
  /** their role */
  role?: string;
  /** link to bio */
  link?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppMember',
  props: {
    name: null,
    role: null,
    link: null
  },
  setup(__props: any) {

const props = __props as {
  /** member name */
  name: string;
  /** their role */
  role?: string;
  /** link to bio */
  link?: string;
}



/** get member img src with fallback if not found */
const src = computed(() => {
  const image = kebabCase(deburr((props.name || "").toLowerCase()));
  try {
    return require(`@/assets/team/members/${image}.jpg`);
  } catch (error) {
    return require(`@/assets/team/_member.jpg`);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_AppLink = _resolveComponent("AppLink")!

  return (_openBlock(), _createBlock(_component_AppLink, {
    to: __props.link || '',
    class: "member"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _unref(src),
            alt: __props.name,
            loading: "lazy"
          }, null, 8, _hoisted_3)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(__props.name), 1),
        (__props.role)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(__props.role), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})